(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.RevalF01SharedCopy = api;
    api.mount(root);
  }
})(typeof window !== 'undefined' ? window : this, function () {
  var TARGET = '51418024739111';
  function activeContext(state) {
    if (state.pageType === 'product' && String(state.selectedVariantId) === TARGET) return true;
    return !!(state.cartHasTarget && (state.pageType === 'cart' || state.drawerOpen));
  }
  function applyCopies(doc, active) {
    doc.querySelectorAll('[data-reval-f01-shared-copy]').forEach(function (node) {
      var original = node.nextElementSibling;
      if (!original || !original.matches('template[data-reval-f01-shared-original]')) return;
      if (active) {
        var replacement = node.getAttribute('data-reval-f01-replacement') || '';
        if (node.textContent !== replacement) node.textContent = replacement;
      } else if (node.innerHTML !== original.innerHTML) {
        node.replaceChildren(original.content.cloneNode(true));
      }
      node.setAttribute('data-reval-f01-shared-active', String(active));
    });
  }
  function mount(win) {
    var doc = win.document;
    var context = doc.querySelector('[data-reval-f01-shared-context]');
    if (!context) return;
    var state;
    try { state = JSON.parse(context.textContent || '{}'); } catch (_) { return; }
    state.cartHasTarget = state.cartHasTarget === true;
    var availability = doc.querySelector('[data-reval-variant-availability][data-product-id="' + state.productId + '"]');
    var productRoot = availability && availability.closest('.product-section');
    var ownedIds = [];
    if (availability) {
      try { ownedIds = JSON.parse(availability.textContent || '{}').variants.map(function (v) { return String(v.id); }); } catch (_) {}
    }
    var drawer = doc.getElementById('CartDrawer');
    function refresh() {
      state.drawerOpen = !!(drawer && drawer.classList.contains('drawer--is-open'));
      applyCopies(doc, activeContext(state));
    }
    function readSelection() {
      if (state.pageType !== 'product') return;
      var field = productRoot && productRoot.querySelector('form.product-single__form[action*="/cart/add"] [name="id"]');
      if (field && field.value) state.selectedVariantId = String(field.value);
    }
    function onVariant(event) {
      var variant = event.detail && event.detail.variant;
      if (variant && ownedIds.indexOf(String(variant.id)) !== -1) state.selectedVariantId = String(variant.id);
      else readSelection();
      refresh();
    }
    api.updateCart = function (hasTarget) {
      state.cartHasTarget = hasTarget === true;
      refresh();
    };
    if (productRoot) productRoot.addEventListener('variantChange', onVariant);
    doc.addEventListener('variant:change', onVariant);
    doc.addEventListener('product:variant-change', onVariant);
    doc.addEventListener('cart:updated', function (event) {
      var cart = event.detail && event.detail.cart;
      if (cart && Array.isArray(cart.items)) api.updateCart(cart.items.some(function (item) { return String(item.variant_id || item.id) === TARGET; }));
    });
    doc.addEventListener('drawerOpen.CartDrawer', function () { win.setTimeout(refresh, 0); });
    doc.addEventListener('drawerClose.CartDrawer', function () { win.setTimeout(refresh, 0); });
    doc.addEventListener('shopify:section:load', refresh);
    win.addEventListener('popstate', function () { readSelection(); refresh(); });
    win.addEventListener('pageshow', function () { readSelection(); refresh(); });
    if (drawer && win.MutationObserver) {
      new win.MutationObserver(refresh).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    readSelection();
    refresh();
  }
  var api = { variantId: TARGET, activeContext: activeContext, applyCopies: applyCopies, mount: mount, updateCart: function () {} };
  return api;
});
